<template>
    <div class="col-md-12 p-0">
        <div class="card">
            <div class="card-body">
                <form class="form-horizontal mt-lg" @submit="submit">
                        <div class="form-group" v-if="!$store.state.loading.status">
                            <label class="col-sm-3">Branch Station <small class="text-danger">*</small></label>
                            <div class="col-sm-3">
                                <SelectBranch  v-on:processBranch="processBranch" :default_id="model.id_branch" :title="'disable'"/>
                                <small class="text-danger" v-if="msg_error.id_branch">{{ msg_error.id_branch[0] }}</small>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-sm-3 ">Client Name <small class="text-danger">*</small></label>
                            <div class="col-sm-9">
                                <input type="text" class="form-control"  placeholder="...." v-model="model.name">
                                <small class="text-danger" v-if="msg_error.name">{{ msg_error.name[0] }}</small>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-sm-3 ">Email Address <small class="text-danger">*</small></label>
                            <div class="col-sm-9">
                                <input type="email" class="form-control"  placeholder="...." v-model="model.email">
                                <small class="text-danger" v-if="msg_error.email">{{ msg_error.email[0] }}</small>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-sm-3 ">Phone Number <small class="text-danger">*</small></label>
                            <div class="col-sm-9">
                                <input type="text" class="form-control"  placeholder="...." v-model="model.phone_number">
                                <small class="text-danger" v-if="msg_error.phone_number">{{ msg_error.phone_number[0] }}</small>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-sm-3 ">Client Address <small class="text-danger">*</small></label>
                            <div class="col-sm-9">
                                <input type="text" class="form-control" v-model="provinces_name" readonly/>
                                <small class="text-danger" v-if="msg_error.id_propinsi">{{ msg_error.id_propinsi[0] }}</small>
                             </div>
                        </div>
                        <div class="form-group">
                            <label class="col-sm-3 "></label>
                            <div class="col-sm-9">
                                <select v-model="model.id_kota"  class="form-control" :disabled="model_kota.length > 0 ? false : true">
                                    <option disabled value="">-- Pilih Kabupaten --</option>
                                    <option v-for="(items, idx) in model_kota" :value="items.id" :key="idx">{{ items.name }}</option>
                                </select>
                                <small class="text-danger" v-if="msg_error.id_kota">{{ msg_error.id_kota[0] }}</small>
                            </div>
                        </div>
                        <div class="form-group" v-if="isEnableMaps">
                            <label class="col-sm-3"></label>
                            <div class="col-sm-9" >
                                <Gmap name="example" :default_model="markerCoordinates"  ></Gmap>
                                <small class="text-danger" v-if="msg_error.office_address">{{ msg_error.office_address[0] }}</small>
                                <small class="text-danger" v-if="msg_error.lat">{{ msg_error.lat[0] }}</small>
                                <small class="text-danger" v-if="msg_error.lng">{{ msg_error.lng[0] }}</small>
                            </div>
                        </div>
                    
                    <hr/>
                    <div class="form-group">
                        <div class="col-md-12 text-center">
                            <a href="javascript:;" class="btn btn-secondary mr-3" @click="$router.go(-1)">CANCEL</a>
                            <button type="submit" class="btn btn-primary btn-full-screen">Submit Data</button>
                        </div>
                    </div>
                </form>
            </div> 
        </div> 
    </div> 
</template>

<script>
    import { mapState } from 'vuex';
    import Gmap from '../../../services/Gmap';
    import $ from 'jquery';
    import axios from 'axios';
    import SelectBranch from '../../Branch/@SelectBranch';

    export default 
    {   
         components: {
            Gmap,
            SelectBranch
        },
        data() {
            return {
                isEnableMaps : false,
                provinces_name : '',
                meta_url : 'client',
                model_kota : [],
                markerCoordinates: [],
            };
        },
        computed: {
            ...mapState('crud', {
                model: state => state.data_model,
                msg_error: state => state.error,
            }),
        },
        created(){
            this.provinces_name = localStorage.getItem('provinces_name');
            this.QueryData();
        },
        methods: 
        {
            processBranch(data)
            {
                this.model.id_branch = data;
            },
            async QueryData()
            {
                let data = await this.$store.dispatch('crud/find', { url: this.meta_url+'/find/'+localStorage.getItem('QUERY_ID')} );
                if(data){
                    this.markerCoordinates = {latitude: parseFloat(data.lat), longitude: parseFloat(data.lng), address : data.office_address};
                    this.isEnableMaps = true;
                    this.fetchKota();
                }
            },
            
            async fetchKota()
            {
                this.model_kota = JSON.parse(localStorage.getItem('data_regencies'));
            },
            submit(e) 
            {
                e.preventDefault();
                this.$store.state.loading.msg = 'Processing submit data...';
                this.$store.state.loading.status = true;

                // google lat and lng
                this.model.office_address = document.getElementById('input_address').value;
                this.model.lat = document.getElementById('input_lat').value;
                this.model.lng = document.getElementById('input_lon').value;  
                
                let data = { url: this.meta_url + '/update/'+localStorage.getItem('QUERY_ID'), callback_url:this.meta_url + '/data', form_data: this.model };
                this.$store.dispatch('crud/storeData', data );
            }
        }
    }
</script>
